import { Modal, ModalWidth } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const t = translationKeys.mainMenuTileItem.recordAgainModal;

type AiAssistantMainMenuTileItemRecordAgainModalProps = { onConfirm: VoidFunction; onClose: VoidFunction };

export const AiAssistantMainMenuTileItemRecordAgainModal = (
   props: AiAssistantMainMenuTileItemRecordAgainModalProps
): JSX.Element => (
   <Modal
      testId={'recordAgain'}
      title={t.title}
      onCancel={props.onClose}
      onCloseRequest={props.onClose}
      onConfirm={props.onConfirm}
      confirmationButtonLabel={t.yes}
      cancelButtonLabel={t.no}
      width={ModalWidth.WIDE}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
   >
      <Translate>{t.message}</Translate>
   </Modal>
);
